import { useState, useEffect, useCallback } from 'react';
import { toast, Toaster } from 'react-hot-toast';
import { getInventoryDropdown } from '../utils/api';
import WholesaleOrderPanelForm from './WholesaleOrderPanelForm';
import OrderCustomerFieldsCollapsible from './OrderCustomerFieldsCollapsible';

const WholesaleOrderPage = () => {
  const [inventory, setInventory] = useState([]);
  const [customerName, setCustomerName] = useState('');
  const [phone, setPhone] = useState('');
  const [customerAddress, setCustomerAddress] = useState('');

  useEffect(() => {
    const fetchInventory = async () => {
      try {
        const data = await getInventoryDropdown('wholesale');
        setInventory(data);
      } catch (error) {
        toast.error(error.message || 'Failed to load inventory');
      }
    };
    fetchInventory();
  }, []);

  useEffect(() => {
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');

    return () => {
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    };
  }, []);

  const resetCustomer = useCallback(() => {
    setCustomerName('');
    setPhone('');
    setCustomerAddress('');
  }, []);

  return (
    <>
      <Toaster position="top-right" />
      <div className="flex flex-col h-full min-h-0 overflow-hidden bg-gradient-to-br from-blue-50 to-indigo-100 py-1 md:py-4">
        <div className="container mx-auto px-4 flex flex-col flex-1 min-h-0">
          <div className="max-w-6xl mx-auto flex flex-col flex-1 min-h-0 w-full">
            <div className="shrink-0 mb-2 space-y-2">
              <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-2">
                <div className="shrink-0">
                  <h1 className="text-xl md:text-2xl font-bold text-gray-800">New Wholesale Order</h1>
                  <p className="hidden md:block text-xs text-gray-500">
                    Ctrl+Enter · Tap models to add · review bucket in footer
                  </p>
                </div>
                <div className="w-full lg:max-w-2xl lg:flex-1">
                  <OrderCustomerFieldsCollapsible
                    customerName={customerName}
                    phone={phone}
                    customerAddress={customerAddress}
                    onCustomerNameChange={setCustomerName}
                    onPhoneChange={setPhone}
                    onCustomerAddressChange={setCustomerAddress}
                    accentFocus="focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>
            </div>

            <div className="flex flex-col flex-1 min-h-0">
              <WholesaleOrderPanelForm
                inventory={inventory}
                customerName={customerName}
                phone={phone}
                customerAddress={customerAddress}
                onResetCustomer={resetCustomer}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WholesaleOrderPage;
